// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const deleteTimesheetProposalEntryPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  entry_id: z.coerce.string().describe("Proposal entry ID"),
});

export const deleteTimesheetProposalEntryHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Entry deleted successfully
 */
export const deleteTimesheetProposalEntry200Schema = z.object({
  message: z.coerce.string(),
  deleted_entry_id: z.number().int(),
});

/**
 * @description Entry not found
 */
export const deleteTimesheetProposalEntry404Schema = z.object({
  message: z.coerce.string(),
});

export const deleteTimesheetProposalEntryMutationResponseSchema = z.lazy(() => deleteTimesheetProposalEntry200Schema);
